var map = {
	"./addtext.svg": "78bd",
	"./back.svg": "7338",
	"./backgrid.svg": "cce6",
	"./backlist.svg": "be24",
	"./backlittle.svg": "abaa",
	"./barcode.svg": "b632",
	"./botlay.svg": "7c8a",
	"./chartbar.svg": "9528",
	"./chartjs.svg": "af50",
	"./chartnext.svg": "f870",
	"./chartpack.svg": "f8e2",
	"./close.svg": "8b1b",
	"./compcar.svg": "a554",
	"./compgrd.svg": "1343",
	"./copy.svg": "8aac",
	"./delete.svg": "0d45",
	"./disable.svg": "8479",
	"./downdrop.svg": "cf1f",
	"./drag.svg": "88c6",
	"./duplicate.svg": "5ca2",
	"./edit.svg": "daf0",
	"./embed.svg": "d5d0",
	"./emoji.svg": "9325",
	"./gtext.svg": "17db",
	"./home.svg": "ac9d",
	"./image.svg": "931c",
	"./lftlay.svg": "bf05",
	"./line.svg": "aa4c",
	"./listcolnone.svg": "e4c1",
	"./listcoltree.svg": "5dc4",
	"./listcoltwo.svg": "4136",
	"./lock.svg": "9619",
	"./markup.svg": "07d61",
	"./mediacrt.svg": "0663",
	"./mediaemb.svg": "7f44",
	"./mediaimg.svg": "31eb",
	"./modeall.svg": "4933",
	"./modeauto.svg": "72d0",
	"./modecontain.svg": "fe27",
	"./modecover.svg": "9acd",
	"./modefit.svg": "9921",
	"./newprj.svg": "d3c7",
	"./next.svg": "0043",
	"./nextmini.svg": "6496",
	"./notfound.svg": "9e4d",
	"./options.svg": "7ead",
	"./optionspos.svg": "f6b44",
	"./overlay.svg": "bb08",
	"./overlayauto.svg": "fc48",
	"./overlaynone.svg": "7d13",
	"./paste.svg": "acb9",
	"./pdf.svg": "5730",
	"./plugdown.svg": "d112",
	"./plugins.svg": "a6fe",
	"./plugup.svg": "f282",
	"./plus.svg": "eb38",
	"./plusgrey.svg": "832f",
	"./pluspos.svg": "8402",
	"./present.svg": "4577",
	"./prev.svg": "ed83",
	"./prevmini.svg": "2d0e",
	"./qrcode.svg": "8b10",
	"./rgtlay.svg": "fe0d",
	"./rightdrop.svg": "ac0f",
	"./shape.svg": "22cc",
	"./spaneq.svg": "efc9",
	"./spanmed.svg": "d65e",
	"./spanorm.svg": "df3c",
	"./spantxt.svg": "5979",
	"./stepall.svg": "c3a4",
	"./steplist.svg": "7abd",
	"./stepnone.svg": "9ad4",
	"./svg.svg": "9bb4",
	"./tableau.svg": "cf77",
	"./text.svg": "d36f",
	"./toplay.svg": "bd6e",
	"./txtsizeauto copy.svg": "2d24",
	"./txtsizeauto.svg": "42f3",
	"./txtsizefit.svg": "ee04",
	"./txtsizenowrap.svg": "0ed0",
	"./unlock.svg": "d901",
	"./video.svg": "512b",
	"./youtube.svg": "11ef",
	"./zoomfocus.svg": "9b86",
	"./zoomin.svg": "617a",
	"./zoomout.svg": "bdd3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";